import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { EnvironmentService } from './environment.service';
/**
 * The Servie to get/change the RSS News Feeds
 */
@Injectable({
  providedIn: 'root'
})
export class RssService {
  /**
   * constructor
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {

  }

  /**
   * Ge the paginated RSS Feeds
   * @param page 
   * @param size 
   * @returns 
   */
  getRssFeeds(page, size): Observable<any> {
    const params = new HttpParams({
      fromObject: {
        page: page,
        size: size
      }
    })
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/news/feed`, { params })
      )
    )
  }

  /**
   * Create a new RSS Feed
   * @param rssFeed 
   * @returns 
   */
  createRssFeed(rssFeed) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/news/feed`, rssFeed)
      )
    )
  }
  /**
   * Delete a RSS Feed
   * @param rssFeedID 
   * @returns 
   */
  deleteRssFeeds(rssFeedID) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.delete(`${url}/news/feed/${rssFeedID}`)
      )
    )
  }
  /**
   * Refresh the RSS Feed (load the new entries)
   * @param rssFeed 
   * @returns 
   */
  refreshRssFeed(rssFeed) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.patch(`${url}/news/feed/${rssFeed.publicId}`, rssFeed)
      )
    )
  }
  /**
   * Get a RSS Feed via the ID
   * @param rssFeedID 
   * @returns 
   */
  getRssFeed(rssFeedID) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/news/feed/${rssFeedID}`)
      )
    )
  }
  /**
   * Edit the RSS Feed via the ID
   * @param rssFeed 
   * @returns 
   */
  editRssFeed(rssFeed) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.put(`${url}/news/feed/${rssFeed.publicId}`, rssFeed)
      )
    )
  }
}
